import { MasterSheetList } from './views';

export default {
  list: MasterSheetList,
  name: 'job-pending-resource',
  label: 'Labor List',
  to: '/job-pending-resource',
};
